<div class="confirmation">
    <h2 mat-dialog-title><mat-icon color="warn">warning</mat-icon> Delete</h2>
    <p>{{ displayText }}</p>
    <div class="btn-group" role="group">
        <button mat-button mat-dialog-close>No</button>
        <button mat-button [mat-dialog-close]="true">Yes</button>
    </div>
</div>